<template>
    <sc-image v-if="isEditMode" :media="mainImage" :editable="editable"/>
    <img v-else v-lazy="mainImage.src" :alt="mainImage.alt">
</template>

<script>
import { Image } from '@sitecore-jss/sitecore-jss-vue'
import { createNamespacedHelpers } from 'vuex'
import { processScImage } from '~/helpers/cloudinary-adapter'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'CustomImage',
  props: {
    media: {
      type: Object,
      default: () => ({})
    },
    size: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapJssGetters(['isEditMode']),
    mainImage () {
      return this.isEditMode ? this.media : processScImage(this.media.value, this.size)
    }
  },
  components: {
    ScImage: Image
  }
}
</script>